import { ajax } from 'discourse/lib/ajax';
import DiscourseRoute from 'discourse/routes/discourse';

export default class ProxyviewsMethodologyRoute extends DiscourseRoute {
  async model() {
    return await ajax('/methodology.json');
  }

  titleToken() {
    return 'Testing & Verification Methodology';
  }
}
